// Module
var code = "<em class=\"character-count\" ng-show=\"model.getCharactersRemaining() < inputMaxLength\" ng-class=\"model.getCharacterCountClass(model.getCharactersRemaining())\" translate=\"ENTER_SALES.SALE_SUMMARY.NOTE_CHARACTERS_REMAINING\" translate-values=\"{ charactersRemaining: '{{ model.getCharactersRemaining() }}' }\"></em>";
// Exports
export default code;